import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { QrCode, MessageCircle } from "lucide-react";
import HabanoQRModal from "./HabanoQRModal";

/**
 * Share popup — QR + WhatsApp only (per spec). Used by creators on Custom
 * Location detail pages. Opaque #171717 surface with gold border.
 */
export default function ShareQRWhatsAppDialog({ open, onOpenChange, locationName, publicUrl }) {
  const [qrOpen, setQrOpen] = useState(false);

  const onWhatsApp = () => {
    const msg = `Hey I found this place on Habano App — ${locationName}. Check it out: ${publicUrl}`;
    const url = `https://wa.me/?text=${encodeURIComponent(msg)}`;
    window.open(url, "_blank");
    onOpenChange?.(false);
  };

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent
          data-testid="share-popup"
          className="max-w-md p-0 border-0"
          style={{
            background: "#171717",
            border: "1px solid rgba(232,184,75,0.3)",
            borderRadius: 18,
          }}
        >
          <DialogHeader className="px-6 pt-6 pb-3">
            <DialogTitle className="font-display text-xl text-foreground">
              Share location
            </DialogTitle>
            <DialogDescription className="text-[13px] text-foreground/55">
              Send {locationName} to a friend.
            </DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-2 gap-3 px-6 pb-6">
            <button
              type="button"
              data-testid="share-qr-btn"
              onClick={() => { setQrOpen(true); }}
              className="flex flex-col items-center gap-2 py-6 transition-transform hover:-translate-y-0.5"
              style={{
                minHeight: 96,
                background: "rgba(232,184,75,0.08)",
                border: "1px solid rgba(232,184,75,0.3)",
                borderRadius: 14,
                color: "#E8B84B",
              }}
            >
              <QrCode className="w-8 h-8" strokeWidth={1.5} />
              <span className="font-display text-base">QR Code</span>
            </button>
            <button
              type="button"
              data-testid="share-whatsapp-btn"
              onClick={onWhatsApp}
              className="flex flex-col items-center gap-2 py-6 transition-transform hover:-translate-y-0.5"
              style={{
                minHeight: 96,
                background: "rgba(37,211,102,0.10)",
                border: "1px solid rgba(37,211,102,0.5)",
                borderRadius: 14,
                color: "#25D366",
              }}
            >
              <MessageCircle className="w-8 h-8" strokeWidth={1.5} />
              <span className="font-display text-base">WhatsApp</span>
            </button>
          </div>
        </DialogContent>
      </Dialog>
      <HabanoQRModal
        open={qrOpen}
        onOpenChange={(v) => { setQrOpen(v); if (!v) onOpenChange?.(false); }}
        url={publicUrl}
        title={locationName}
        subtitle="Scan to view on Habano"
      />
    </>
  );
}
